import React from 'react';
import './PlaceholderPage.css';

const ViewProductsPage = () => {
  return (
    <div className="placeholder-page">
      <h1 className="page-title">View Products</h1>
      <p className="page-description">
        Product listing with Update and Delete actions will be added here.
      </p>
      
      <div className="placeholder-actions">
        <button className="action-btn" onClick={() => alert('Update functionality will be added soon!')}>Update</button>
        <button className="action-btn action-btn-danger" onClick={() => alert('Delete functionality will be added soon!')}>Delete</button>
      </div>
    </div>
  );
};

export default ViewProductsPage;
